import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index'
import BootstrapVue from 'bootstrap-vue'
import vbclass from 'vue-body-class'
import Toasted from 'vue-toasted'
import VeeValidate from 'vee-validate'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'
import VueCryptojs from 'vue-cryptojs'
import VueGtag from 'vue-gtag'
import VueSocketIOExt from 'vue-socket.io-extended'
import { io } from 'socket.io-client'
import VueGtm from '@gtm-support/vue2-gtm'
import VueFacebookPixel from 'vue-facebook-pixel'
import VueStepWizard from 'vue-step-wizard'
import VueSignature from 'vue-signature-pad'
import GlobalPlugin from './global-plugin'
import { encrypt, decrypt, isObjectEmpty } from './utils/functions'

Vue.use(VueStepWizard)

Vue.use(VueFacebookPixel)

console.log('SOCKET IN ENV FILE : ', process.env.VUE_APP_SOCKET_URL)
console.log('DISABLE LOGS IN ENV FILE : ', process.env.VUE_APP_DISABLE_LOGS)

const socket = io(process.env.VUE_APP_SOCKET_URL)

import {
    VueAuthenticateConfig,
    VeeValidateConfig,
    ToastedConfig,
} from '@/config'
import './plugins/vee-validate/rules'

// Load the full build.
window._ = require('lodash')

Vue.use(require('vue-moment'))
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, VueAuthenticateConfig)
Vue.use(VeeValidate, VeeValidateConfig)
Vue.use(Toasted, ToastedConfig)
Vue.use(BootstrapVue)
Vue.use(vbclass, router)
Vue.use(VueCryptojs)
Vue.use(GlobalPlugin)
Vue.use(VueSignature)
Vue.use(VueSocketIOExt, socket)
Vue.use(VueGtm, {
    id: 'GTM-NJDK6XF', // GTM-NJDK6XF Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    queryParams: {
        // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
        gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
        gtm_preview: 'env-4',
        gtm_cookies_win: 'x',
    },
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    nonce: '2726c7f26c', // Will add `nonce` to the script tag
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: process.env.VUE_APP_DISABLE_LOGS !== 'true', // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
})

if (process.env.VUE_APP_GTAG == 'true') {
    Vue.use(VueGtag, {
        config: { id: 'G-V0ZG5CMFQ' },
    })
}
if (process.env.VUE_APP_FB_PIXEL == 'true') {
    Vue.analytics.fbq.init(process.env.VUE_APP_FB_PIXEL_ID, {
        em: 'user@mail.com',
    })
}
Vue.config.productionTip = false

require('@/auto-import.js')
require('@/route-middleware')
require('@/interceptor')
require('./filters')
require('./directives/authenticated-image')
// Adding to Vue prototype
Vue.prototype.$encrypt = encrypt
Vue.prototype.$decrypt = decrypt
Vue.prototype.$isObjectEmpty = isObjectEmpty
window.httpRequest = Vue.prototype

new Vue({
    router: router,
    store,
    watch: {
        $route: function () {
            this.checkMeta()
            this.pageTop()
        },
    },
    // sockets: {
    //     connect: function() {
    //         console.log('Socket-check: ', 'socket connected 1234')
    //     },
    //     test: function() {
    //         console.log('got hit back')
    //     },
    // },
    methods: {
        checkMeta() {
            document.title =
                process.env.VUE_APP_TITLE + ' | ' + this.$route.meta.title
        },
        pageTop() {
            window.scrollTo(0, 0)
        },
    },
    render: (h) => h(App),
}).$mount('#app')
